import { Component, OnInit, OnDestroy, Renderer2 , ViewChild, TemplateRef, ElementRef, AfterViewInit} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';

import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';

import { DeviceDetectorService  } from 'ngx-device-detector';

//import { NavService } from './services/nav.service';



import { Idle ,DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';



import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';


import { AppService } from 'app/app.service';
import { AuthService } from 'app/shared/auth.service';
import { AlertmessageService } from 'app/shared/alertmessage.service';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss'],
  providers:[BsModalService,AppService]
})
export class TimeoutComponent implements OnInit 
{

  test1:boolean;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  title = 'angular-idle-timeout';

  public modalRef: BsModalRef;

  @ViewChild('childModal', {  }) childModal: ModalDirective;
  constructor(private idle: Idle, 
    private keepalive: Keepalive,
    private appService:AppService,
    public authService:AuthService,
    private modalService: BsModalService,
    public alert:AlertmessageService,
    public router:Router,
    public dialog: MatDialog) 
  { 

     // sets an idle timeout of 5 seconds, for testing purposes.
     //15 mins
     idle.setIdle(900);
     // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
     idle.setTimeout(30);
     // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
     idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

     
    idle.onIdleEnd.subscribe(() => {
      // console.log("1");
           this.idleState = 'No longer idle.'
           //console.log(this.idleState);
           this.reset();
         });
     
     
         idle.onTimeout.subscribe(() => {
          //console.log("2");
           this.idleState = 'Your session has expired. Please log in again.';
           this.timedOut = true;
           this.test1=true;  
           this.dialog.closeAll();
            this.alert.openConfirmationDialogTimeOut('Your session has expired. Please log in again.');
           //this._notificationService.showNotification({ type: 'success', message: 'Session has expired!Login to continue using the Web Portal' });
           //this.router.navigate(['/']);
         
         });
     
         idle.onIdleStart.subscribe(() => {
          // console.log("3");
           //console.log("TEST");
           this.idleState = 'You\'ve gone idle!'
           // console.log(this.idleState);
           this.childModal.show();
         });
     
         idle.onTimeoutWarning.subscribe((countdown) => {
       //console.log("4");
           this.idleState = 'You will time out in ' + countdown + ' seconds!'
     
           // console.log(this.idleState);
         });
     
         // sets the ping interval to 15 seconds
         keepalive.interval(15);
     
         keepalive.onPing.subscribe(() => this.lastPing = new Date());
     
         this.appService.getUserLoggedIn().subscribe(userLoggedIn => {
           //this.test1=true;
     
           
           if (userLoggedIn) {
            // console.log("6");
             idle.watch()
             this.timedOut = true;
           } else {
            // this.dialog.closeAll()
             //console.log("7");
           
             idle.stop();
           }
         })
     
     
     
         //this.reset();
     
       }
       reset() {
         //console.log("8");
         this.idle.watch();
         this.idleState = 'Started.';
         this.timedOut = false;
       }
       hideChildModal(): void {
         //console.log("9");
         this.childModal.hide();
       }
     
       stay() {
         //console.log("10");
         this.childModal.hide();
         this.reset();
       }
     
       logout() {
         //console.log("11");
         this.childModal.hide();
         this.appService.setUserLoggedIn(false);
         this.dialog.closeAll();
        this.authService.logout();
        //this.dialog.closeAll()
         //this.alert.openConfirmationDialogTimeOut('Session has expired!Login to continue using the Web Portal');
        // this.router.navigate(['/']);
       }
     
       ngOnInit() {
        // console.log(this.test1)
       //this.test1=false;
         console.log("Timeout component");
       }
     
     }
     